(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5906"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5906"] = parcelRequire;
}
parcelRequire.register("7meeL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf; }, function (v) { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03; }, function (v) { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03 = v; });
var $55b5a1b0c0eb630f$export$6503ec6e8aabbaf;
var $55b5a1b0c0eb630f$export$f7ad0328861e2f03;
"use strict";
var $55b5a1b0c0eb630f$var$mapping = {};
function $55b5a1b0c0eb630f$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$55b5a1b0c0eb630f$var$mapping[keys[i]] = pairs[keys[i]];
}
function $55b5a1b0c0eb630f$var$resolve(id) {
    var resolved = $55b5a1b0c0eb630f$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$55b5a1b0c0eb630f$export$6503ec6e8aabbaf = $55b5a1b0c0eb630f$var$register;
$55b5a1b0c0eb630f$export$f7ad0328861e2f03 = $55b5a1b0c0eb630f$var$resolve;

});

var $33ba857d78189f46$exports = {};

(parcelRequire("7meeL")).register(JSON.parse('{"kbjbz":"index.df2420a9.js","lIoGD":"FoodLogo.0e921e3d.png","bd3o2":"AboutImage.aa9d90b8.jpg","5ZdJq":"app_store.90a92e73.png","aGO0x":"play_store.4caa5192.jpg","5VhnP":"FoodImage2.d39812e7.png","1XKxr":"google.b9f7e6d9.png","3Rzl0":"FoodImage1.a2a2656b.png","gsu29":"DemoImage.a9c94cae.jpg","aYokX":"EmptyCart.fc3619c3.png","1idCF":"HomePage.31b43ea9.js","9s0c9":"FoodImagePage.543b04df.png","jf007":"HomePage.cb35aafc.css","ir1ST":"Menu.217b0a4b.js","9TcZR":"RestaurantMenu.a0b2e19b.js","fVlgR":"index.73444f7d.css"}'));

})();
//# sourceMappingURL=index.a429d93d.js.map
